import { Injectable } from '@angular/core';
import { HttpService } from './core/http.service';
import { URLService } from './_url.service';
import { Observable } from 'rxjs/internal/Observable';
import { ResponseData } from './model/response.model';


@Injectable({
  providedIn: 'root'
})
export class RdcprimaryDataService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

  GetRDCPrimaryDataList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetRDCPrimaryDataListUrl, filterModel);
  }
}
